<template>
    <div>
        <label v-if="label">{{ label }}</label>

        <!-- Text Input -->
        <input class="form-input shadow-sm focus:ring-secondary focus:border-secondary block w-full sm:text-sm border-gray-300 rounded-md"
            v-if="type === 'text'"
            :type="type"
            v-model="localValue"
            :placeholder="placeholder"
        />

        <!-- Tags Input -->
        <vue-tags-input
            class="rounded w-full focus:border-secondary"
            v-if="type === 'tags'"
            v-model="tagsInput"
            :tags="tags"
            @tags-changed="newTags => localValue = newTags.map(item => item.text)"
        />

        <!-- Select Input -->
        <select v-if="type === 'select'" v-model="localValue" class="form-input shadow-sm focus:ring-secondary focus:border-secondary block w-full sm:text-sm border-gray-300 rounded-md">
            <option v-for="option in selectOptions" :key="option.value" :value="option.value">
                {{ option.text }}
            </option>
        </select>
    </div>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";
import InputText from "./InputText.vue";
import SelectSmall from "./SelectSmall.vue";

export default {
    components: {SelectSmall, InputText, VueTagsInput },
    props: {
        type: { type: String, required: true }, // Type of input: text, tags, or select
        label: { default: "" }, // Input label
        value: { required: true }, // v-model binding
        placeholder: { type: String, default: "" }, // Placeholder for text input
        selectOptions: { // Options for the select dropdown
            type: Array,
            default: () => [],
        },
    },
    watch: {
        // Watch for changes in localValue and emit it to the parent
        localValue(newValue) {
            this.$emit('input', newValue);
        },
        // Watch for changes in the prop value and update localValue accordingly
        value(newValue) {
            this.localValue = newValue;
        }
    },
    data() {
        return {
            // Create a local property that mirrors the prop value
            localValue: this.value,
            tagsInput: "",
        };
    },

    computed: {
        tags: {
            get: function get() {
                return this.localValue.map(item => ({
                    text: item
                }));
            },
        }
    },
};
</script>

<style>
.ti-tag {
    background-color: rgb(248 178 65 / var(--tw-bg-opacity)) !important;
}
.vue-tags-input {
    max-width: none !important;
    border-radius: 0.25rem;
}
.ti-input {
    margin-bottom: 1rem;
    padding: 1rem;
    border: 1px solid #ddd;
    border-radius: 5px;
}
</style>